/*
  The active organization and ranch: which tenant the user is working in right now.

  Every tenant shares one origin (brief §2.6), so the scope is explicit state, not a
  property of the URL. The API client stamps it onto every request as X-Organization-Id
  and X-Ranch-Id; the outbox stamps it onto every command AT CAPTURE TIME, so a command
  recorded under ranch A syncs under ranch A even after the user switches to B (§8.2).

  A tiny external store (useSyncExternalStore) rather than React context, because the
  API client and the sync engine read it outside the tree.
*/

export interface Scope {
  organizationId: string
  ranchId: string
}

let current: Scope | null = null
const listeners = new Set<() => void>()

export function getScope(): Scope | null {
  return current
}

export function setScope(scope: Scope | null): void {
  if (current?.organizationId === scope?.organizationId && current?.ranchId === scope?.ranchId) {
    return
  }
  current = scope
  for (const listener of listeners) listener()
}

export function subscribeScope(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Test seam. */
export function resetScopeForTests(): void {
  current = null
  listeners.clear()
}
